import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { commandsEntityActions } from 'containers/App/modules/entities/commands/commandsEntity.slice';
import {
	createResetGridDataAction,
	createSetGridParamsAction,
	createSetGridParamsReducer,
	GRID_INITIAL_STATE,
} from 'containers/Grid/grid.utils';

const STATE_KEY = 'commandsPage';
const GRID_STATE_KEY = 'commandsGrid';

const setGridParams = createSetGridParamsAction(GRID_STATE_KEY);
const resetGridData = createResetGridDataAction(GRID_STATE_KEY);

const updateCommandsGridReducer = (state, action) => {
	const { metadata, requestParams } = action.payload || {};
	const totalResults = metadata?.page?.totalResults;
	if (totalResults !== undefined) {
		state[GRID_STATE_KEY].params.pagination.total = totalResults;
	}
	if (requestParams) {
		state[GRID_STATE_KEY].lastRequestParams = requestParams;
	}
};

const commandsGridInitialState = {
	...GRID_INITIAL_STATE,
	lastRequestParams: null,
};

const resetCommandsGridReducer = (state) => {
	state[GRID_STATE_KEY] = {
		...commandsGridInitialState,
		lastRequestParams: null,
	};
};

export const INITIAL_STATE = {
	[GRID_STATE_KEY]: commandsGridInitialState,
};

const slice = createSlice({
	name: STATE_KEY,
	initialState: INITIAL_STATE,
	reducers: {},
	extraReducers: {
		[commandsEntityActions.fetchCommandsSuccess]: updateCommandsGridReducer,
		[setGridParams]: createSetGridParamsReducer(GRID_STATE_KEY),
		[resetGridData]: resetCommandsGridReducer,
	},
});

const getState = (state) => state[STATE_KEY] || INITIAL_STATE;

const selectCommandsGrid = createSelector(
	getState,
	(state) => state[GRID_STATE_KEY]
);

const selectLastRequestParams = createSelector(
	getState,
	(state) => state[GRID_STATE_KEY]?.lastRequestParams
);

export const commandsPageSelectors = {
	selectCommandsGrid,
	selectLastRequestParams,
};

export const commandsPageActions = {
	setGridParams,
	resetGridData,
	fetchCommands: commandsEntityActions.fetchCommands,
};

export default slice.reducer;
